module.exports = __webpack_public_path__ + "img/1316834618.a0aac9f4.jpg";